import React, { FunctionComponent } from 'react';
import './index.scss';

type Props = {
    color: 'darkgreen' | 'yellow' | 'white' | 'green' | 'lightgreen';
};

export const ArrowButton: FunctionComponent<Props> = ({ color }) => (
    <svg
        className={`arrow-button ${color}`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 186.3 186.3"
    >
        <g clipPath={`url(#clippath-${color})`}>
            <circle
                className="background-circle"
                cx="93.1"
                cy="93.1"
                r="90.6"
            />
            <polygon
                className="arrow"
                points="94.6 128.2 129.6 93.1 94.6 58.1 89.1 63.6 114.8 89.3 56.7 89.3 56.7 97 114.8 97 89.1 122.7 94.6 128.2"
            />
        </g>
        <g clipPath={`url(#clippath-1-${color})`}>
            <circle
                className="border-circle"
                cx="93.1"
                cy="93.1"
                r="90.6"
                fill="none"
                strokeWidth="4.4"
            />
        </g>
    </svg>
);
